import React from 'react';

const SvgError = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.759 12l2.877-2.876a1.243 1.243 0 10-1.759-1.76L12 10.241 9.124 7.364a1.245 1.245 0 00-1.76 1.76L10.241 12l-2.877 2.877a1.245 1.245 0 001.76 1.76L12 13.758l2.877 2.877a1.241 1.241 0 001.759 0 1.245 1.245 0 000-1.759L13.759 12z",
  fillRule: "evenodd"
}));

export default SvgError;